import { Button as MuiButton } from '@mui/material';
import styled from '@mui/material/styles/styled';

export const Button = styled(MuiButton)(() => ({
    borderRadius: 10,
    minWidth: 0,
    width: '120px !important',
    height: '65px !important',
    border: '3px solid',
    padding: 0,
    textTransform: 'capitalize',
}));
